export const TpaHandlerProviderSymbol = Symbol('TpaHandlerProvider')
export const TpaSrcQueryParamProviderSymbol = Symbol('TpaSrcQueryParamProvider')
export const ForceSymbol = Symbol('Force')
